import { DuctType, type Damper as DamperType } from "@eisox/api/core-api";
import { cn } from "@eisox/design-system";

import { m } from "~/paraglide/messages";

import { hasDuctReading, type DuctSensors } from "../helpers";
import { Position } from "../types";
import { Damper } from "./damper";
import { DamperDialog } from "./damper-dialog";
import { Filter } from "./filter";
import { Inlet } from "./inlet";
import * as RecirculationDamper from "./recirculation-damper";
import { Sensors } from "./sensors";

interface ExhaustProps {
  buildingId: string;
  airHandlerUnitId: string;
  position?: Position;
  temperature?: number;
  temperatureDefect?: boolean;
  damper?: DamperType;
  recirculationDamper?: DamperType;
  sensors?: DuctSensors;
  airFilterPressureSwitchDefect?: boolean;
}

const Exhaust: React.FC<ExhaustProps> = ({
  buildingId,
  airHandlerUnitId,
  position = Position.TOP,
  temperature,
  temperatureDefect,
  damper,
  recirculationDamper,
  sensors,
  airFilterPressureSwitchDefect,
}) => (
  <div
    className={cn(
      "gap-2.5 pr-2.5 relative flex flex-row items-center [grid-area:exhaust] *:shrink-0",
      "after:left-16.25 after:h-23.5 after:absolute after:-z-2 after:w-[calc(100%-65px)] after:border-y after:border-primary-dark-gray after:bg-neutral-100 after:content-['']",
      position === Position.TOP ? "*:self-end after:-bottom-px" : "*:self-start after:-top-px",
    )}
  >
    <Inlet
      buildingId={buildingId}
      airHandlerUnitId={airHandlerUnitId}
      type={DuctType.EXHAUST}
      position={position}
      temperature={temperature}
      temperatureDefect={temperatureDefect}
    />
    {damper && (
      <DamperDialog buildingId={buildingId} airHandlerUnitId={airHandlerUnitId} damper={damper}>
        <Damper {...damper} position={position} />
      </DamperDialog>
    )}
    {sensors && hasDuctReading(sensors) && (
      <Sensors buildingId={buildingId} airHandlerUnitId={airHandlerUnitId} position={position} {...sensors} />
    )}
    {recirculationDamper && (
      <DamperDialog buildingId={buildingId} airHandlerUnitId={airHandlerUnitId} damper={recirculationDamper}>
        <RecirculationDamper.Damper {...recirculationDamper} />
      </DamperDialog>
    )}
    {airFilterPressureSwitchDefect !== undefined && (
      <Filter position={position} defect={airFilterPressureSwitchDefect} label={m.air_handler_unit_filter_exhaust()} />
    )}
  </div>
);

Exhaust.displayName = "Exhaust";

export { Exhaust };
export type { ExhaustProps };
